<template>
  <div class="img_box" @click.stop>
    <div v-if="msg.menus && msg.menus.length&&msg.menus[0].title">
      <div class="video_special" @click="$downapppop.open">
        <div class="video_cover">
          <img v-lazy="msg.menus[0].v_cover || msg.menus[0].v_img" alt />
          <div class="play_btn">
            <img :src="require('@/assets/images/icon-play-btn@2x.png')" alt />
          </div>
        </div>
        <div class="video_special_detail">
          <div>
            <h4>{{msg.menus[0].title}}</h4>
            <p>{{msg.menus[0].video_desc}}</p>
          </div>
          <dl>
            <dt>
              <img :src="require('@/assets/images/icon-video @2x.png')" alt />
            </dt>
            <dd>查看视频</dd>
          </dl>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="thumbnail">
        <div
          ref="imgItem"
          :isrc="item.video_img"
          v-for="(item,i) in msg.menus"
          class="img-item"
          :class="{'img-item-one':msg.image.length==0}"
          :key="i"
        >
          <div class="vedio_img" v-if="item.video">
            <span class="vedio_image">
              <img class="vedio_image_img" :src="item.video_img" alt />
              <!-- todo -->
              <p @click="clickPlay(item.video)">
                <img
                  class="vedio_play"
                  src="https://cdn.aigupiao.com/static/wrap/img/media_play_ico.png"
                />
                <span class="vedio_time">
                  <img
                    class="vedio_time_icon"
                    src="https://cdn.aigupiao.com/static/wrap/img/small_video_ico1.png"
                  />
                  <i>{{item.video_len}}s</i>
                </span>
              </p>
            </span>
          </div>
        </div>
        <div
          ref="imgItem"
          :isrc="item"
          class="img-item"
          v-if="msg.image && msg.image.length"
          v-for="(item,index) in msg.image"
          :class="{'img-item-one':msg.image.length==1 && (!msg.menus || msg.menus.length==0)}"
          :key="'index'+index"
        >
          <img class="live_img" @load="$previewRefresh" :preview="randomStr" v-lazy="item" alt="图片" />
        </div>
        <div
          ref="imgItem"
          :isrc="item"
          class="img-item"
          v-else-if="msg.img_hd.length"
          v-for="(item,o) in msg.img_hd"
          :class="{'img-item-one':msg.img_hd.length==1 && (!msg.menus || msg.menus.length==0)}"
          :key="'o'+o"
        >
          <img class="live_img" @load="$previewRefresh" :preview="randomStr" v-lazy="item" alt="图片" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "imageViewpoint",
  props: {
    msg: Object
  },
  data() {
    return {
      randomStr: Math.random()
        .toString(36)
        .slice(-4)
    };
  },

  created() {},
  mounted() {
    // // 设置缩略图的样式。
    // if (this.$refs.imgItem && this.$refs.imgItem.length > 0) {
    //   this.$refs.imgItem.forEach(element => {
    //     let eWidth = element.offsetWidth;
    //     let isOneImg = element.classList.contains("img-item-one");
    //     element.style.height = eWidth + "px";
    //     let isrc = element.getAttribute("isrc");
    //     let live_img = element.querySelectorAll("img.live_img")[0];
    //     let video_img = element.querySelectorAll(".vedio_image_img")[0];
    //     if (live_img && !isOneImg) {
    //       live_img.style.opacity = "0";
    //       element.style.cssText =
    //         "height:" +
    //         eWidth +
    //         "px;background-image:url(" +
    //         isrc +
    //         ");background-size:cover;background-position:50%;background-repeat:no-repeat;background-clip:content-box;";
    //     } else if (video_img && !isOneImg) {
    //       video_img.style.opacity = "0";
    //       element.style.cssText =
    //         "height:" +
    //         eWidth +
    //         "px;background-image:url(" +
    //         isrc +
    //         ");background-size:cover;background-position:50%;background-repeat:no-repeat;background-clip:content-box;";
    //     }
    //     if (isOneImg) {
    //       //但张图片或视频的时候
    //       let _img = new Image();
    //       _img.onload = function() {
    //         let maxHeight = 230;
    //         let maxWidth = 230;
    //         let tempWidth = 0;
    //         let tempHeight = 0;
    //         if (_img.width > 0 && _img.height > 0) {
    //           if (_img.width / _img.height >= 1) {
    //             //横向图
    //             var o_height = Math.ceil(_img.height / (_img.width / maxWidth));
    //             o_height = o_height > 175 ? o_height : 175;
    //             tempWidth = maxWidth;
    //             tempHeight = o_height;
    //           } else {
    //             //竖向图
    //             var o_width = Math.ceil(_img.width / (_img.height / maxHeight));
    //             o_width = o_width > 175 ? o_width : 175;
    //             tempHeight = maxHeight;
    //             tempWidth = o_width;
    //           }
    //           element.style.cssText = `width:${tempWidth}px;height:${tempHeight}px;position:relative`;
    //           if (live_img) {
    //             live_img.style.opacity = "0";
    //             element.style.cssText = `width:${tempWidth}px;height:${tempHeight}px;background-image:url("${isrc}");background-size:cover;background-position:50%;background-repeat:no-repeat;background-clip:content-box;`;
    //           } else if (video_img) {
    //             video_img.style.opacity = "0";
    //             element.style.cssText = `width:${tempWidth}px;height:${tempHeight}px;background-image:url("${isrc}");background-size:cover;background-position:50%;background-repeat:no-repeat;background-clip:content-box;`;
    //           }
    //         }
    //       };
    //       _img.src = isrc;
    //     }
    //   });
    // }
    // 设置缩略图的样式。
    if (this.$refs.imgItem && this.$refs.imgItem.length > 0) {
        this.$refs.imgItem.forEach((element) => {
          let eWidth = element.offsetWidth;
          let live_img = element.querySelectorAll("img.live_img,img.vedio_image_img")[0];
          let isOneImg = element.classList.contains("img-item-one"); //是否是单独的
          let isrc = element.getAttribute("isrc");
          element.style.height = eWidth + "px";
          let _img = new Image();
          _img.onload = function () {
            let maxHeight = (eWidth * 5) / 3;
            let maxWidth = (eWidth * 5) / 3;
            let oneMaxHeight = (maxHeight * 3) / 4;
            let tempWidth = 0;
            let tempHeight = 0;
            if (!isOneImg) {
              if (_img.width / _img.height >= 1) {
                //横向图
                live_img.classList.add("widthlong");
              } else {
                //竖向图
                live_img.classList.add("heightlong");
              }
            } else {
              if (_img.width / _img.height >= 1) {
                //横向图
                var o_height = Math.ceil(
                  _img.height / (_img.width / maxWidth)
                );
                o_height =
                    o_height > oneMaxHeight
                        ? o_height
                        : oneMaxHeight;
                tempWidth = maxWidth;
                tempHeight = o_height;
                live_img.classList.add("widthlong");
              } else {
                //竖向图
                var o_width = Math.ceil(
                  _img.width / (_img.height / maxHeight)
                );
                o_width =
                    o_width > oneMaxHeight
                        ? o_width
                        : oneMaxHeight;
                tempHeight = maxHeight;
                tempWidth = o_width;
                live_img.classList.add("heightlong");
              }
              $(live_img).attr('data-size', `${tempWidth}x${tempHeight}`)
              element.style.cssText = `width:${tempWidth}px;height:${tempHeight}px;`;
            }
          };
          _img.src = isrc;
        });
      }
  },
  methods: {
    clickPlay(src) {
      this.$videoplay.open(src);
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

.live_item .thumbnail .img-item-one {
  width: rem2(231px) !important;
  height: rem2(174px) !important;
}

.live_item {
  padding: 0 rem2(10px);
  box-sizing: border-box;

  &.isDetail {
    padding: 0;
  }
}

.img_box {
  padding-top: rem2(10px);
  padding: 7px 14px 0;
}

//图片样式
.thumbnail {
  display: flex;
  flex-wrap: wrap;

  .img-item {
    position: relative;
    overflow: hidden;
    width: 33.33%;
    padding: rem2(0px);
    border: rem2(3px) solid transparent;
    box-sizing: border-box;
    margin: 0;

    &.img-item-is_hide {
      width: 0;
      height: 0;
      overflow: hidden;
      visibility: hidden;
    }

    .heightlong {
      position: absolute;
      width: 100%;
      height: auto;
      top: 50%;
      transform: translateY(-50%);
    }

    .widthlong {
      position: absolute;
      height: 100%;
      width: auto;
      left: 50%;
      transform: translateX(-50%);
    }

    .paly_video {
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: rem2(-15px);
      margin-left: rem2(-15px);
      display: flex;
      width: rem2(30px);
      height: rem2(30px);
      overflow: hidden;
      border-radius: 50%;
      border: rem2(2px) solid #ffffff;
      justify-content: center;
      align-items: center;
      background: rgba(0, 0, 0, 0.15);

      >.icon {
        font-size: rem2(13px);
        margin-left: rem2(3px);
      }
    }

    .video_len {
      position: absolute;
      display: flex;
      align-items: center;
      height: rem2(19px);
      padding: 0 rem2(5px);
      right: 0;
      bottom: 0;
      border-radius: rem2(5px) 0 0 0;
      background: rgba(0, 0, 0, 0.55);
      font-size: rem2(11px);
      color: #fefffe;

      >.icon {
        font-size: rem2(12px);
        margin-right: rem2(4px);
      }
    }

    .image_c {
      list-style: none;
      word-break: break-all;
      word-wrap: break-word;
      margin: 0;
      padding: 0;
      border: 0;
      outline: 0;
      vertical-align: baseline;
      background: transparent;
      display: inline-block;
      position: absolute;
      z-index: 0;
      width: rem2(35px);
      height: rem2(22px);
      background-color: rgba(119, 115, 115, 0.8);
      border-bottom-left-radius: rem2(6px);
      right: rem2(0px);
      color: rgb(254, 255, 254);
      text-align: center;
      user-select: none;
      cursor: pointer;
      font-size: rem2(12px);
      line-height: rem2(22px);
    }
  }

  >div {
    height: rem2(111px);
    width: rem2(111px);

    >img {
      width: 100%;
      height: 100%;
    }
  }
}

//视频专辑样式
.video_special {
  padding: rem2(6px) rem2(4px) 0;

  .video_cover {
    height: rem2(198px);
    position: relative;

    >img {
      width: 100%;
      height: 100%;
    }

    .play_btn {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: rem2(-23px);
      margin-left: rem2(-23px);
      width: rem2(47px);
      height: rem2(47px);

      >img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .video_special_detail {
    display: flex;
    box-sizing: content-box;
    height: rem2(60px);
    justify-content: space-between;
    padding: 0 rem2(10px);
    background: #f5f6f7;

    >div {
      height: 100%;
      display: flex;
      flex-direction: column;

      >h4 {
        height: rem2(17px);
        font-size: rem2(15px);
        color: #222222;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-weight: 400;
        margin: rem2(10px) 0 rem2(8px) 0;
        line-height: rem2(17px);
      }

      >p {
        font-size: rem2(14px);
        // color:@color-gray-middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #636363;
        font-size: rem2(13px);
      }
    }

    >dl {
      flex-shrink: 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      // justify-content: space-around;
      align-items: center;

      >dt {
        width: rem2(27px);
        height: rem2(22px);
        margin: rem2(9px) 0 rem2(6px) 0;

        >img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      >dd {
        font-size: rem2(14px);
        color: #fe696b;
      }
    }
  }
}

.vedio_img {
  height: 100%;

  .vedio_image {
    display: block;
    height: 100%;
    position: relative;

    >img {
      height: 100%;
      width: 100%;
    }

    p {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;

      .vedio_time {
        position: absolute;
        bottom: 0;
        right: 0;
        width: rem2(70px) !important;
        height: rem2(23px) !important;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .vedio_time_icon {
          line-height: rem2(23px);
          width: rem2(14px) !important;
          height: rem2(14px) !important;
          margin-left: rem2(7px);
        }

        >i {
          color: #fff;
          font-size: rem2(14px) !important;
          line-height: rem2(23px) !important;
          padding-left: rem2(10px);
          font-style: normal;
          white-space: nowrap;
        }
      }
    }
  }
}

.vedio_play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: rem2(30px) !important;
  height: rem2(30px) !important;
}
</style>